import { SearchResult } from '@/models/Repository'
import actions from '@/vuex/modules/accountList/actions'
import getters from '@/vuex/modules/accountList/getters'
import mutations from '@/vuex/modules/accountList/mutations'

const state = {
  loading: {
    searchResult: true,
    searchInvitationsResult: true,
    agencyList: true,
    advertiserList: true,
    systemOwnerList: true,
  },
  searchResult: new SearchResult(),
  searchInvitationsResult: new SearchResult(),
  systemOwnerList: new SearchResult(),
  agencyList: [],
  advertiserList: new SearchResult(),
  agencyListForSearch: [],
  advertiserListForSearch: new SearchResult(),
}

const advertiser = {
  state,
  namespaced: true,
  getters,
  actions,
  mutations,
}

export default advertiser
